import { atom } from 'recoil'

export type DriversAtomType = {
  view: string
}

const DEFAULT_STATE = {
  view: 'list',
}

export const driversAtom = atom<DriversAtomType>({
  key: 'driverState',
  default: DEFAULT_STATE,
})
